class ConditionalFields {
  constructor() {
    this.selectors = {
      conditional: '.js-conditional',
    };

    this.classnames = {
      hidden: 'is-hidden',
    };

    this.init();
  }

  init() {
    const conditionalFields = document.querySelectorAll(this.selectors.conditional);

    if (conditionalFields.length === 0) {
      return;
    }

    conditionalFields.forEach((field) => {
      this.toggleConditional(field);

      field.addEventListener('change', () => {
        this.toggleConditional(field);
      });
    });
  }

  toggleConditional = (field) => {
    const conditional = field.getAttribute('name');
    const conditionalElements = document.querySelectorAll(`[data-conditional="${conditional}"]`);

    const { value } = field;
    const conditionals = document.querySelectorAll(
      `[data-conditional="${conditional}"][data-conditional-value="${value}"]`,
    );

    conditionalElements.forEach((el) => {
      el.classList.add(this.classnames.hidden);

      const formFields = el.querySelectorAll(
        'input:not([type="submit"]):not([type="button"]), select, textarea',
      );

      formFields.forEach((formField) => {
        formField.disabled = true;
        if (formField.hasAttribute('required')) {
          formField.dataset.wasRequired = 'true';
          formField.removeAttribute('required');
        }
      });
    });

    conditionals.forEach((el) => {
      el.classList.remove(this.classnames.hidden);

      const formFields = el.querySelectorAll(
        'input:not([type="submit"]):not([type="button"]), select, textarea',
      );

      formFields.forEach((formField) => {
        formField.disabled = false;
        if (formField.dataset.wasRequired === 'true') {
          formField.setAttribute('required', '');
          delete formField.dataset.wasRequired;
        }
      });
    });
  };
}

export default () => {
  new ConditionalFields();
};
